<template>
    <div>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.landTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.surface_terrain"
                                      prop="surface_terrain">
                            <el-input   v-mask="'#################'" v-model.number="post.surface_terrain" type="surface_terrain">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                                      >
                            <el-input   v-mask="'#################'" v-model.number="post.longueur_terrain" type="longueur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain"
                                      >
                            <el-input   v-mask="'#################'" v-model.number="post.largeur_terrain" type="largeur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.lotissement">
                            <el-radio border size="small" v-model="post.lotissement" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio border size="small" v-model="post.lotissement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.constructible">
                            <el-radio border size="small" v-model="post.constructible" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio border size="small" v-model="post.constructible" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$labels.exposition">
                            <el-select
                                    v-model="post.exposition"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                        :key="expositionChoice"
                                        :label="expositionChoice"
                                        :value="expositionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$labels.belle_vue">
                            <el-radio border size="small" v-model="post.belle_vue" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio border size="small" v-model="post.belle_vue" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Avec vis-à-vis">
                            <el-radio border size="small" v-model="post.vis_a_vis" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio border size="small" v-model="post.vis_a_vis" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.certificat_urbanisme">
                            <el-radio border size="small" v-model="post.certificat_urbanisme" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio border size="small" v-model="post.certificat_urbanisme" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.shon"
                                      prop="shon"
                                     >
                            <el-input   v-mask="'#################'" v-model.number="post.shon" type="shon">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cos"
                                      prop="cos"
                                     >
                            <el-input  type="number" v-model="post.cos" step="0.01">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'

export default {
  name: 'PostEditImmoObject4300',
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['environnement', 'mandat_statut', 'modalites_recuperation_charges_locatives', 'exposition']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
